<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="data.article.name"
  submitLabel="Open in New Tab"
  (cancel)="handleMoreIsComplete(false)"
  (submit)="handleMoreIsComplete(true)"
>
  <div crucibleDialogContent>
    @if (data.useUrl && safeUrl) {
      <div class="container">
        <iframe [src]="safeUrl" class="responsive-iframe"></iframe>
      </div>
    }

    @if (!data.useUrl && data.article && data.article.description) {
      <div class="viewer">
        <div class="page">
          <angular-editor class="angular-editor" [ngModel]="data.article.description" [config]="editorConfig"></angular-editor>
        </div>
      </div>
    }
  </div>

</crucible-dialog>
